import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { UserProxy } from 'src/app/core/store/user/user.proxy';
import { filter } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
  selector: '[has-claim]'
})
export class HasclaimdirectiveDirective implements OnInit, OnDestroy {

  @Input('has-claim') claimName: string;
  @Input() disableThreshold: number = 0;
  @Input() mode: 'disable' | 'visibility' = 'disable';
  private hasUserClaim = false;
  private hasUserClaimValue: any;
  private destroy$ = new Subject<void>();
  
  constructor(private el: ElementRef, private renderer: Renderer2, private userProxy: UserProxy) { }
  
  ngOnInit(): void {
    if (this.claimName) {
      // Subscribe to userClaims$ to reactively update when claims change
      this.userProxy.userClaims$
        .pipe(
          filter(claims => claims !== null),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          this.checkClaim();
        });
      
      // Initial check
      this.checkClaim();
    }
    else {
      this.updateState();
    }
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['claimName'] && this.claimName) {
      this.checkClaim();
    }
  }
  
  private checkClaim(): void {
    this.userProxy.hasClaim(this.claimName).subscribe((has: boolean) => {
      this.hasUserClaim = has;
      if (this.hasUserClaim) {
        this.userProxy.getClaimValue(this.claimName).subscribe((hasValue: any) => {

          this.hasUserClaimValue = hasValue;
          this.updateState();
        });
      }
      else {
        this.updateState();
      }
    });
  }
  
  private updateState() {
    const isDisableMode = this.mode === 'disable';
    const isVisibilityMode = this.mode === 'visibility';

    let claimOk = false;

    if (this.hasUserClaim) {
      if (typeof this.hasUserClaimValue === 'boolean') {
        claimOk = this.hasUserClaimValue;
      } else if (typeof this.hasUserClaimValue === 'number') {
        claimOk = this.hasUserClaimValue > this.disableThreshold;
      } else {
        claimOk = !!this.hasUserClaimValue;
      }
    }

    // show when claim FAILS in visibility mode
    if (isVisibilityMode) {
      const shouldShow = !claimOk;
      this.renderer.setStyle(this.el.nativeElement, 'display', shouldShow ? '' : 'none');
    }

    // disable when claim FAILS in disable mode
    if (isDisableMode) {
      const shouldDisable = !claimOk;
      if (shouldDisable) {
        this.renderer.addClass(this.el.nativeElement, 'is-disabled');
        this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
      } else {
        this.renderer.removeClass(this.el.nativeElement, 'is-disabled');
        this.renderer.removeStyle(this.el.nativeElement, 'pointer-events');
      }
    }
  }

}